import {
    AfterViewInit,
    ChangeDetectionStrategy,
    Component,
    ElementRef,
    ViewChild,
} from '@angular/core';
import { NgClass, NgOptimizedImage } from '@angular/common';
import { ContainerComponent } from 'sharedWidgets/container/container.component';
import { RouterOutlet } from '@angular/router';
import { TrackBarWidgetComponent } from 'templates/widgets/track-bar-widget/track-bar-widget.component';
import { DebugDisplayWidgetComponent } from 'sharedWidgets/debug-display-widget/debug-display-widget.component';
import { PremiumBannerSimpleWidgetComponent } from 'templates/widgets/premium-banner-widget/premium-banner-simple-widget.component';
import { MiniTrackBarComponent } from 'templates/widgets/mini-track-bar-widget/mini-track-bar';
import { SlideElementInOutDirective } from 'shared/base/generics/directives/slide-element-in-out.directive';
import { QuoteBasePage } from './quote-base-page.component';

@Component({
    selector: 'virseker-base-page',
    templateUrl: './html/virseker-base-page.component.html',
    styleUrls: ['./css/virseker-base-page.component.less'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        NgOptimizedImage,
        DebugDisplayWidgetComponent,
        ContainerComponent,
        PremiumBannerSimpleWidgetComponent,
        RouterOutlet,
        TrackBarWidgetComponent,
        MiniTrackBarComponent,
        NgClass,
        SlideElementInOutDirective,
    ],
})
export class VirsekerBasePageComponent extends QuoteBasePage implements AfterViewInit {
    @ViewChild('pageHeader', { read: ElementRef }) private readonly headerElementRef: ElementRef;
    premiumTop: string;

    ngAfterViewInit(): void {
        this.premiumTop = `${this.headerElementRef?.nativeElement?.offsetHeight}px`;
        this.cRef.markForCheck();
    }

    windowResize(): void {
        this.premiumTop = `${this.headerElementRef?.nativeElement?.offsetHeight}px`;
        this.cRef.markForCheck();
    }
}
